// extracted by mini-css-extract-plugin
module.exports = {"Title":"Wishlist_Title__1_tKn","Main":"Wishlist_Main__OdaGh","SubText":"Wishlist_SubText__2EmE-","Home":"Wishlist_Home__1clHg","Wishlist":"Wishlist_Wishlist__jFoaQ"};